import { Controller } from "@hotwired/stimulus"

// Provides visual feedback when auth forms are submitted
export default class extends Controller {
  static targets = ["submitButton", "buttonText", "spinner"]

  submit(event) {
    // Show loading state immediately
    this.showLoading()

    // Allow the form to submit naturally
    // The loading state will persist until page navigation
  }

  showLoading() {
    // Disable the button
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add('opacity-75', 'cursor-not-allowed')

    // Hide button text and show spinner
    this.buttonTextTarget.classList.add('invisible')
    this.spinnerTarget.classList.remove('hidden')
  }
}
